import { DateTime } from 'luxon';
import {
  RegistrationBewareFormVM,
  SubjectAttributesVM,
} from 'mutation/view-models/registration-beware';
import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const validationSchema = yup
  .object()
  .shape({
    subjectAttributes: yup
      .object()
      .nullable()
      .shape({
        disabled: yup.boolean().nullable(),
        formBeware: yup
          .object()
          .nullable()
          .shape({
            typology: yup.string().nullable().required('Il campo è obbligatorio'),
            // italian
            dateForm: yup
              .date()
              .typeError('Data non valida')
              .nullable()
              .required('Il campo è obbligatorio'),
            year: yup
              .string()
              .nullable()
              .required('Il campo è obbligatorio')
              .matches(regexOnlyNumber, 'Il campo deve essere numerico'),
            note: yup.string().nullable().required('Il campo è obbligatorio'),
          }),
      })
      // errors state
      .test(
        'subjectAttributes.formBeware.municipalityItalian.description',
        'Campo obbligatorio',
        (values) => {
          const castedValues = values as unknown as SubjectAttributesVM;

          if (
            !castedValues?.formBeware?.isForeign &&
            !castedValues?.formBeware?.municipalityItalian?.description
          ) {
            return new yup.ValidationError(
              'Campo obbligatorio',
              undefined,
              'subjectAttributes.formBeware.municipalityItalian.description'
            );
          }

          return true;
        }
      )
      .test(
        'subjectAttributes.formBeware.municipalityForeign.description',
        'Campo obbligatorio',
        () => {
          // const castedValues = values as unknown as SubjectAttributesVM;

          // if (castedValues?.isForeign && !castedValues?.municipalityForeign?.description) {
          //   return new yup.ValidationError(
          //     'Campo obbligatorio',
          //     undefined,
          //     'subjectAttributes.municipalityForeign.description'
          //   );
          // }

          return true;
        }
      )
      .test('subjectAttributes.formBeware.foreignState.id', 'Campo obbligatorio', () => {
        // const castedValues = values as unknown as SubjectAttributesVM;

        // if (castedValues?.isForeign && !castedValues?.foreignState?.id) {
        //   return new yup.ValidationError(
        //     'Campo obbligatorio',
        //     undefined,
        //     'subjectAttributes.foreignState.id'
        //   );
        // }

        return true;
      }),
    registrationNewPerson: yup
      .object()
      .nullable()
      .shape({
        fiscalCode: yup.string().nullable(),
        surname: yup.string().nullable(),
        name: yup.string().nullable(),
        gender: yup.string().nullable(),
        birthDate: yup
          .date()
          .nullable()
          .max(DateTime.now(), 'La data deve essere minore del giorno corrente'),
        isForeignBirth: yup.boolean().nullable(),
        italianBirth: yup
          .object()
          .nullable()
          .shape({
            municipality: yup.object().nullable().shape({
              description: yup.string().nullable(),
            }),
          }),
        foreignBirth: yup
          .object()
          .nullable()
          .shape({
            foreignState: yup.object().nullable().shape({
              id: yup.string().nullable(),
            }),
          }),
        isForeignDomicile: yup.boolean().nullable(),
        italianDomicile: yup
          .object()
          .nullable()
          .shape({
            municipality: yup.object().nullable().shape({
              description: yup.string().nullable(),
            }),
          }),
        foreignDomicile: yup
          .object()
          .nullable()
          .shape({
            foreignState: yup.object().nullable().shape({
              id: yup.string().nullable(),
            }),
          }),
        address: yup.string().nullable(),
      }),
  })
  // errors new person
  .test('registrationNewPerson.fiscalCode', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as RegistrationBewareFormVM;

    if (
      castedValues.subjectAttributes?.disabled &&
      !castedValues.registrationNewPerson?.fiscalCode
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'registrationNewPerson.fiscalCode'
      );
    }

    return true;
  })
  .test('registrationNewPerson.surname', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as RegistrationBewareFormVM;

    if (castedValues.subjectAttributes?.disabled && !castedValues.registrationNewPerson?.surname) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'registrationNewPerson.surname'
      );
    }

    return true;
  })
  .test('registrationNewPerson.name', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as RegistrationBewareFormVM;

    if (castedValues.subjectAttributes?.disabled && !castedValues.registrationNewPerson?.name) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'registrationNewPerson.name');
    }

    return true;
  })
  .test('registrationNewPerson.gender', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as RegistrationBewareFormVM;

    if (castedValues.subjectAttributes?.disabled && !castedValues.registrationNewPerson?.gender) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'registrationNewPerson.gender'
      );
    }

    return true;
  })
  .test('registrationNewPerson.birthDate', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as RegistrationBewareFormVM;

    if (
      castedValues.subjectAttributes?.disabled &&
      !castedValues.registrationNewPerson?.birthDate
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'registrationNewPerson.birthDate'
      );
    }

    return true;
  })
  .test(
    'registrationNewPerson.italianBirth.municipality.description',
    'Campo obbligatorio',
    (values) => {
      const castedValues = values as unknown as RegistrationBewareFormVM;

      if (
        castedValues.subjectAttributes?.disabled &&
        !castedValues.registrationNewPerson?.isForeignBirth &&
        !castedValues.registrationNewPerson?.italianBirth?.municipality?.description
      ) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'registrationNewPerson.italianBirth.municipality.description'
        );
      }

      return true;
    }
  )
  .test('registrationNewPerson.foreignBirth.foreignState.id', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as RegistrationBewareFormVM;

    if (
      castedValues.subjectAttributes?.disabled &&
      castedValues.registrationNewPerson?.isForeignBirth &&
      !castedValues.registrationNewPerson?.foreignBirth?.foreignState?.id
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'registrationNewPerson.foreignBirth.foreignState.id'
      );
    }

    return true;
  })
  .test(
    'registrationNewPerson.italianDomicile.municipality.description',
    'Campo obbligatorio',
    (values) => {
      const castedValues = values as unknown as RegistrationBewareFormVM;

      if (
        castedValues.subjectAttributes?.disabled &&
        !castedValues.registrationNewPerson?.isForeignDomicile &&
        !castedValues.registrationNewPerson?.italianDomicile?.municipality?.description
      ) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'registrationNewPerson.italianDomicile.municipality.description'
        );
      }

      return true;
    }
  )
  .test('registrationNewPerson.foreignDomicile.foreignState.id', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as RegistrationBewareFormVM;

    if (
      castedValues.subjectAttributes?.disabled &&
      castedValues.registrationNewPerson?.isForeignDomicile &&
      !castedValues.registrationNewPerson?.foreignDomicile?.foreignState?.id
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'registrationNewPerson.foreignDomicile.foreignState.id'
      );
    }

    return true;
  })
  .test('registrationNewPerson.address', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as RegistrationBewareFormVM;

    if (castedValues.subjectAttributes?.disabled && !castedValues.registrationNewPerson?.address) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'registrationNewPerson.address'
      );
    }

    return true;
  });
